import "core-js/modules/es6.date.now";
import * as Caml_builtin_exceptions from "./caml_builtin_exceptions.js";

function caml_sys_getenv(s) {
  if (typeof process === "undefined" || process.env === undefined) {
    throw Caml_builtin_exceptions.not_found;
  }

  var match = process.env[s];

  if (match !== undefined) {
    return match;
  } else {
    throw Caml_builtin_exceptions.not_found;
  }
}

var os_type = function os_type(_) {
  if (typeof process !== 'undefined' && process.platform === 'win32') {
    return "Win32";
  } else {
    return "Unix";
  }
};

function caml_sys_time(param) {
  if (typeof process === "undefined" || process.uptime === undefined) {
    return -1;
  } else {
    return process.uptime();
  }
}

function caml_sys_random_seed(param) {
  return [((Date.now() | 0) ^ 4294967295) * Math.random() | 0];
}

function caml_sys_system_command(_cmd) {
  return 127;
}

var caml_sys_getcwd = function caml_sys_getcwd(param) {
  if (typeof process === "undefined" || process.cwd === undefined) {
    return "/";
  }

  return process.cwd();
};

function caml_sys_get_argv(param) {
  if (typeof process === "undefined") {
    return (
      /* tuple */
      ["", [""]]
    );
  } else {
    var argv = process.argv;

    if (argv == null) {
      return (
        /* tuple */
        ["", [""]]
      );
    } else {
      return (
        /* tuple */
        [argv[0], argv]
      );
    }
  }
}

function caml_sys_exit(exit_code) {
  if (typeof process !== "undefined") {
    return process.exit(exit_code);
  } else {
    return 0;
  }
}

function caml_sys_is_directory(_s) {
  throw [Caml_builtin_exceptions.failure, "caml_sys_is_directory not implemented"];
}

function caml_sys_file_exists(_s) {
  throw [Caml_builtin_exceptions.failure, "caml_sys_file_exists not implemented"];
}

export { caml_sys_getenv, caml_sys_time, os_type, caml_sys_random_seed, caml_sys_system_command, caml_sys_getcwd, caml_sys_get_argv, caml_sys_exit, caml_sys_is_directory, caml_sys_file_exists };
/* No side effect */